/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsDoubleNeSw = createReactComponent("outline", "arrows-double-ne-sw", "IconArrowsDoubleNeSw", [["path", { "d": "M3 14l11 -11", "key": "svg-0" }], ["path", { "d": "M10 3h4v4", "key": "svg-1" }], ["path", { "d": "M10 17v4h4", "key": "svg-2" }], ["path", { "d": "M21 10l-11 11", "key": "svg-3" }]]);

export { IconArrowsDoubleNeSw as default };
//# sourceMappingURL=IconArrowsDoubleNeSw.mjs.map
